// src/reducers/selectedPrescriptionSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PrescriptionType } from "../../interface/GeneralResponse";

interface SelectedPrescriptionState {
  selectedTemplate: PrescriptionType | null;
}

const initialState: SelectedPrescriptionState = {
  selectedTemplate: null,
};

const selectedPrescriptionSlice = createSlice({
  name: "selectedPrescription",
  initialState,
  reducers: {
    setSelectedPrescription(
      state,
      action: PayloadAction<PrescriptionType | null>,
    ) {
      state.selectedTemplate = action.payload;
    },
    clearSelectedPrescription(state) {
      state.selectedTemplate = null;
    },
  },
});

export const { setSelectedPrescription, clearSelectedPrescription } =
  selectedPrescriptionSlice.actions;

export default selectedPrescriptionSlice.reducer;
